import GlobalCurrency from './GlobalCurrency';

export default GlobalCurrency;
